import { render, staticRenderFns } from "./materialBox.vue?vue&type=template&id=5eec4aa0&scoped=true&"
import script from "./materialBox.vue?vue&type=script&lang=js&"
export * from "./materialBox.vue?vue&type=script&lang=js&"
import style0 from "./materialBox.vue?vue&type=style&index=0&id=5eec4aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eec4aa0",
  null
  
)

component.options.__file = "materialBox.vue"
export default component.exports